import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { LicenseQueryKey } from './queryKey';
export const useUpdateLicenseInformation = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((model) => api.base
        .put('/api/License/UpdateLicenseInformation', model)
        .then(res => res.data), {
        onSuccess: (result) => {
            if (!result)
                return;
            queryClient.setQueryData([LicenseQueryKey.Info], result);
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateLicenseInformation: mutateAsync, isSaving: isLoading };
};
export default useUpdateLicenseInformation;
